import axios from "axios";
import config from "../../config";
import { getLoggedInAccessToken } from "../../common/utils";
const instance = axios.create({
  baseURL: config.BASE_URL,
  // timeout: 30000,
  timeout: 420000,
});

export const post = (url, data, dispatch = null) => {
  // console.log("data in Post ::" + url, data);
  return new Promise(async (resolve, reject) => {
    data.tokens = await getLoggedInAccessToken();
    instance
      .post(url, data)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          //console.log("error in Post111", result.data);
          //handle this error when no content found
          if (result.data && result.data.status === 206 && dispatch) {
            reject(undefined);
          }
        }
      })
      .catch((error) => {
        console.log("URL=>", url);
        console.log("data==>", data);
        console.log("error in Post", error.response);

        reject(error);
        alert(error);
      });
  });
};
